<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
      </div>
      <div style="width: 500px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker
              v-model="ruleForm.activityTime"
              type="daterange"
              range-separator="至"
              start-placeholder="请选择开始日期"
              end-placeholder="请选择结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="活动说明" prop="description">
            <el-input v-model="ruleForm.description" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <el-form-item label="消费维度" prop="consumptionType">
            <el-radio-group v-model="configForm.consumptionType">
                      <el-radio label="1">电量</el-radio>
              <el-radio label="2">金额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励梯度" prop="level" style="margin-bottom:0">
            <el-radio-group v-model="configForm.level" @change="levelChange">
              <el-radio label="1">一级</el-radio>
              <el-radio label="2">二级</el-radio>
              <el-radio label="3">三级</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-card v-for="(items,indexs) in configForm.coupons" :key="indexs" class="level-config">
            <div slot="header">
              <span>{{ numberfilter(indexs+1) }}级配置</span>
            </div>
            <el-form-item
              v-if="configForm.consumptionType=='1'"
              label="充电电量"
              :prop="'coupons.' + indexs + '.amount'"
              :rules="configRules.amountRule1"
            >
              <el-input v-model="items.amount" placeholder="请输入电度数">
                <template slot="append">度</template>
              </el-input>
            </el-form-item>
            <el-form-item v-else label="消费金额" :prop="'coupons.' + indexs + '.amount'" :rules="configRules.amountRule2">
              <el-input v-model="items.amount" placeholder="请输入金额">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <template v-for="(row,index) in items.coupons">
              <el-form-item
                :key="index"
                :label="'优惠券'+numberfilter(index+1)"
                :prop="'coupons.' + indexs + '.coupons.'+ index"
                :rules="configRules.couponsRule"
                required
              >
                <div class="d-flex">
                  <el-select v-model="row.couponId" style="width: 200px;" placeholder="请选择优惠券">
                    <el-option
                      v-for="item in allCoupon"
                      :key="item.couponId"
                      :label="item.couponName"
                      :value="item.couponId"
                    />
                  </el-select>
                  <el-input v-model="row.count" class="ml-20" style="width: 100px;" placeholder="请输入数量" />
                  <div class="ml-20">张</div>
                  <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(indexs,index)" />
                  <i
                    v-show="index!==0"
                    class="icon-jia ml-20 el-icon-remove-outline"
                    @click="delCoupon(indexs,index)"
                  />
                </div>
                <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
              </el-form-item>
            </template>
          </el-card>

          <el-form-item label="活动电站" prop="stationType">
            <el-radio-group v-model="configForm.stationType">
              <el-radio v-for="(item, index) in activitystationType" :key="index" :label="item.id">{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择运营商 -->
            <div v-show="configForm.stationType==='2'" class="border">
              <el-input v-model="filterOperatorText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleOperatorChange"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="configForm.stationType==='3'" class="border">
              <el-input v-model="filterStationText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleStationChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" :rules="partakeRules" label-width="100px">
          <el-form-item label="可参与用户" prop="userType">
            <el-radio-group v-model="partakeForm.userType">
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id">{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.userType==='2'" class="border">
              <el-input v-model="filterMechanismText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleMechanismChange"
				:check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType==='3'" class="border">
              <el-input v-model="filterTagText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleTagChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
  numberfilter
} from '@/utils/tool'
export default {
  data() {
    // 优惠券校验
    var validateCoupon = (rule, value, callback) => {
      const strP = /^[1-9]\d*$/
      if (!value.couponId) {
        callback(new Error(`请选择优惠券`))
      } else if (!value.count) {
        callback(new Error(`请输入数量`))
      } else if (!strP.test(value.count)) {
        callback(new Error(`请输入正整数`))
      } else if (this.queryCouponStock(value.couponId) && Number(value.count) > this.queryCouponStock(value.couponId)) {
        callback(new Error('优惠券数量大于库存数量'))
      } else {
        callback()
      }
    }
    return {
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      filterOperatorText: '', // 运营商过滤
      filterStationText: '', // 电站过滤
      filterMechanismText: '', // 企业过滤
      filterTagText: '', // 标签过滤
      ruleForm: {
        name: '', // 活动名称
        activityTime: [], // 活动时间
        description: '' // 活动说明
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        activityTime: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '请输入活动说明',
          trigger: 'blur'
        }]
      },
      // 所有的优惠券数据
      allCoupon: [],
      // 活动电站
      activitystationType: [{
        label: '全部电站',
        id: '1'
      }, {
        label: '选择运营商',
        id: '2'
      }, {
        label: '选择电站',
        id: '3'
      }],
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      configForm: {
        consumptionType: '1', // 消费维度
        level: '1', // 奖励梯度
        coupons: [{
          amount: '', // 消费金额(充电电量) 表示达到多少
          coupons: [{
            couponId: '', // 选择的优惠券
            count: '' // 数量
          }]
        }],
        stationType: '1', // 活动电站单选框
        operator: [], // 选择运行商时的树数据
        station: [] // 选择电站时的树数据
      },
      configRules: {
        consumptionType: [{
          required: true,
          message: '请选择消费维度',
          trigger: 'change'
        }],
        level: [{
          required: true,
          message: '请选择奖励梯度',
          trigger: 'change'
        }],
        amountRule1: [{
          required: true,
          message: '请输入电度数',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d+)?$/,
          message: '请输入正数',
          trigger: 'blur'
        }],
        amountRule2: [{
          required: true,
          message: '请输入消费金额',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d+)?$/,
          message: '请输入正数',
          trigger: 'blur'
        }],
        couponsRule: {
          validator: validateCoupon,
          trigger: ['blur', 'change']
        },
        stationType: [{
          required: true,
          message: '请选择活动电站',
          trigger: 'change'
        }]
      },
      // 可参与用户字段的单选数据
      userTypeItem: [{
        label: '全部用户',
        id: '1'
      }, {
        label: '选择企业',
        id: '2'
      }, {
        label: '选择标签',
        id: '3'
      }],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      partakeForm: {
        userType: '1', // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [] // 选择标签
      },
      partakeRules: {
        userType: [{
          required: true,
          message: '请选择可参与用户',
          trigger: 'change'
        }]
      }
    }
  },
  watch: {
    filterOperatorText(val) {
      this.$refs.treeOperator.filter(val)
    },
    filterStationText(val) {
      this.$refs.treeStation.filter(val)
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    }
  },
  mounted() {
    // 获取全部优惠券数据
    this.loadCoupon()
    // 查询全部运营商方法
    this.getOperatorTree()
    // 查询全部电站方法
    this.getStationTree()
    // 查询全部企业方法
    this.getMechanismTree()
    // 查询全部标签方法
    this.getTagTree()
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0,
        hasStock: true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部运营商树的数据
    getOperatorTree() {
      const data = {
        treeDepth: 'ORG'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.operatorTreeData = resp
        }
      })
    },
    // 查询全部电站树的数据
    getStationTree() {
      const data = {
        treeDepth: 'STATION'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.stationTreeData = resp
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = resp
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType:'0' },
        callback: resp => {
          this.tagTreeData = resp
        }
      })
    },
    // 表单加一级梯度配置
    levelChange() {
      const data = {
        amount: '', // 消费金额(充电电量) 表示达到多少
        coupons: [{
          couponId: '', // 选择的优惠券
          count: '' // 数量
        }]
      }
      const length = Number(this.configForm.level) - this.configForm.coupons.length
      if (length > 0) {
        for (let i = 0; i < length; i++) {
          this.configForm.coupons.push(JSON.parse(JSON.stringify(data)))
        }
      } else {
        for (let i = 0; i < Math.abs(length); i++) {
          this.configForm.coupons.splice(this.configForm.coupons.length - 1, 1)
        }
      }
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    /**
       * 表单添加一行优惠券
       */
    addCoupon(val, index) {
      const data = {
        couponType: '',
        couponNum: ''
      }
      this.configForm.coupons[val].coupons.splice(index + 1, 0, data)
    },
    /**
       * 删除删除一行优惠券
       */
    delCoupon(val, index) {
      this.configForm.coupons[val].coupons.splice(index, 1)
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })

      let configFormBool = false
      this.$refs['configForm'].validate(valid => {
        configFormBool = valid
      })

      let partakeFormBool = false
      this.$refs['partakeForm'].validate(valid => {
        partakeFormBool = valid
      })
      // 如果三个表单都校验通过
      if (ruleFormBool && configFormBool && partakeFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    submitData() {
      // 活动电站下面的树的数据
      let stationValue = ''
      if (this.configForm.stationType === '2') {
        stationValue = this.configForm.operator.join(',')
      } else if (this.configForm.stationType === '3') {
        stationValue = this.configForm.station.join(',')
      }
      // 可参与用户下面的树的数据
      let userValue = ''
      if (this.partakeForm.userType === '2') {
        userValue = this.partakeForm.mechanism.join(',')
      } else if (this.partakeForm.userType === '3') {
        userValue = this.partakeForm.tag.join(',')
      }
      const data = {
        type: 4,
        name: this.ruleForm.name, // 活动名称
        consumptionType: this.configForm.consumptionType, // 消费维度
        description: this.ruleForm.description, // 活动说明
        start: this.ruleForm.activityTime[0], // 活动开始时间
        end: this.ruleForm.activityTime[1], // 活动结束时间
        level: this.configForm.level, // 奖励梯度
        coupons: this.configForm.coupons, // 一二三级配置数组
        stationType: this.configForm.stationType, // 活动电站类型
        stationValue: stationValue, // 活动电站下面的树的数据
        userType: this.partakeForm.userType, // 可参与用户类型
        userValue: userValue // 可参与用户类型下面的树的数据
      }
      this.$store.dispatch('form/handle', {
        url: '/activity/save',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    // 树的节点筛选
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 选择运营商 赋值
    handleOperatorChange(data, checked, indeterminate) {
      this.configForm.operator = this.$refs.treeOperator.getCheckedKeys()
    },
    // 选择电站 赋值
    handleStationChange(data, checked, indeterminate) {
      this.configForm.station = this.$refs.treeStation.getCheckedKeys()
    },
    // 选择企业 赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.partakeForm.mechanism = this.$refs.treeMechanism.getCheckedKeys()
    },
    // 选择标签 赋值
    handleTagChange(data, checked, indeterminate) {
      this.partakeForm.tag = this.$refs.treeTag.getCheckedKeys()
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex {
    display: flex;
  }

  .currentStock {
    height: 20px;
    align-items: center;
  }

  .ml-20 {
    margin-left: 20px;
  }

  .icon-jia {
    font-size: 22px;
    align-items: center;
    display: flex;
  }

  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }

  .flexJCenter {
    display: flex;
    justify-content: center;
  }

  .mt-25 {
    margin-top: 25px;
  }

  /deep/ .el-card.level-config {
    margin: 10px 0;

    .el-card__header {
      font-size: 16px;
      padding: 10px 15px;
    }

    .el-card__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/cumulativeAdd.vue